import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { OFFER_ANCHOR, PRODUCT, PRODUCT_TAGLINE } from '../data/constants';
export function FinalCTA() {
  return <section className="border-t-4 border-leaf bg-white py-5 sm:py-7" data-id="element-39" data-mp="c83odh06bg3y">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-40" data-mp="844a752d8tdr">
        <h2 className="text-center text-2xl leading-none text-forest sm:text-4xl" data-id="element-41" data-mp="m4ylpwkpnagn">
          One last <span className="text-leaf" data-id="element-42" data-mp="m2lvkw4sttsi">question</span>
        </h2>
        <div className="mx-auto mt-1.5 max-w-3xl space-y-1 text-center text-sm leading-snug text-ink sm:text-base" data-id="element-43" data-mp="h5c8hn4vtu7u">
          <p data-id="element-44" data-mp="vtypdta5qu16">
            When you're facing yellowing leaves, unusual discoloration, stunted crop growth,
            nutrient imbalance symptoms, or confusing laboratory findings... Do you have an
            organized visual system to compare the evidence, investigate possible causes, and
            determine what to evaluate next?
          </p>
          <p data-id="element-45" data-mp="2c5g5o456wyuw">
            Stop relying on scattered photographs, disconnected technical references, and
            unstructured crop nutrition assessments.{' '}
            <strong className="font-bold text-forest" data-id="element-46" data-mp="2h5knbxhu3zmp">
              Recognize the symptoms. Compare the patterns. Evaluate the evidence. Make informed
              decisions.
            </strong>
          </p>
        </div>

        <MockupImage className="mt-2" data-id="element-47" data-mp="2v428bngcuy0x" />

        <div className="mt-2 text-center" data-id="element-48" data-mp="2v2zhtgmy2xlj">
          <p className="font-display text-xl font-extrabold uppercase leading-none text-forest sm:text-3xl" data-id="element-49" data-mp="302lsbibe1zqn">
            🌱 {PRODUCT}
          </p>
          <p className="mx-auto mt-1 max-w-2xl font-display text-xs font-semibold uppercase leading-tight tracking-wide text-ink sm:text-base" data-id="element-50" data-mp="34un28xl33edi">
            {PRODUCT_TAGLINE}
          </p>
          <p className="mt-1 font-display text-[11px] font-bold uppercase tracking-wide text-gold-dark sm:text-sm" data-id="element-51" data-mp="3esjbtkydi19i">
            Observe • Compare • Investigate • Analyze • Evaluate • Document
          </p>
        </div>

        <div className="mt-3 flex flex-col items-center" data-id="element-52" data-mp="1jov0hsb1kacw">
          <p className="mb-2 text-center font-display text-base font-extrabold uppercase leading-tight text-forest sm:text-xl" data-id="element-53" data-mp="1eps7554fbskr">
            🔥 GET THE COMPLETE SYSTEM TODAY — <span className="text-leaf" data-id="element-54" data-mp="1sihwnjj5vfmm">$27 USD</span>
          </p>
          <CTAButton href={OFFER_ANCHOR} data-id="element-55" data-mp="1nodnquqc4xiw">🌱 GET {PRODUCT}</CTAButton>
          <TrustLine items={['Immediate Access • Digital Delivery', '🛡️ 7-Day Money-Back Guarantee']} data-id="element-56" data-mp="22e1pty6cc07o" />
        </div>
      </div>
    </section>;
}